import React, { Component } from 'react';
import { Breadcrumb, Container, Header, List, Menu, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../routes';
import { translate } from 'react-i18next';
import { AutoSizer } from 'react-virtualized';
import { connect } from 'react-redux';
import SubNavigationView from './../navigation/SubNavigationBar';

class AdminView extends Component {

  constructor (props) {
    super(props);
  }

  static mapStateToProps (state) {
    return {
      authentication: state.authentication.toJS()
    };
  }

  render () {
    const { t, authentication } = this.props;
    const userRoles =
      authentication && authentication.user && Array.isArray(authentication.user.roles)
        ? authentication.user.roles
        : [];

    return (
      <AutoSizer disableHeight style={{ display: 'flex', flex: 1 }}>
        {
          ({ width }) => {
            let Wrapper = Container;
            let style = {};

            if (width < 764) {
              Wrapper = 'div';
              style = {
                margin: 0,
                width
              };
            }

            return (
              <Wrapper style={style}>
                <SubNavigationView activeLink="administration" roles={userRoles} />

                <Segment vertical secondary style={{ padding: 4 }}>
                  <Breadcrumb>
                    <Breadcrumb.Section as={Link} link to={'/administration'}>Inicio</Breadcrumb.Section>
                    <Breadcrumb.Divider icon="right angle" />
                    <Breadcrumb.Section active>Administracion</Breadcrumb.Section>
                  </Breadcrumb>
                </Segment>

                <List divided relaxed>
                  <List.Item>
                    <List.Icon name="users" size="large" verticalAlign="middle" />
                    <List.Content>
                      <List.Header as={Link} to={ROUTES.ADMIN_USERS}>Administrar usuarios</List.Header>
                      <List.Description>Alta, baja y modificacion de usuarios</List.Description>
                    </List.Content>
                  </List.Item>
                </List>
              </Wrapper>
            );
          }
        }
      </AutoSizer>
    );
  }

}

const i18nEnhancement = translate('translations')(AdminView);

export default connect(AdminView.mapStateToProps)(i18nEnhancement);


// WEBPACK FOOTER //
// ./src/components/views/AdminView.jsx